import {
  findAssistantTargets,
  type AssistantTarget,
} from '@/shared/assistant';

/** How long a target may take to appear after a navigation the turn caused. */
const WAIT_MS = 4000;
const HIGHLIGHT_CLASS = 'assistant-highlight';
const HIGHLIGHT_MS = 2400;

/** Resolve the first visible element with the target, waiting while the screen settles. */
export function waitForTarget(
  target: AssistantTarget
): Promise<HTMLElement | null> {
  return new Promise((resolve) => {
    const started = performance.now();
    const tick = () => {
      const found = findAssistantTargets(target)[0];
      if (found) resolve(found);
      else if (performance.now() - started > WAIT_MS) resolve(null);
      else requestAnimationFrame(tick);
    };
    tick();
  });
}

/** Scroll the element into view and ring it briefly (`highlight`). */
export function highlightElement(element: HTMLElement): void {
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  element.classList.remove(HIGHLIGHT_CLASS);
  // Restart the animation when the same element is pointed at twice.
  void element.offsetWidth;
  element.classList.add(HIGHLIGHT_CLASS);
  window.setTimeout(() => element.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_MS);
}
